import { useEffect, useState } from "react";
import axios from "axios";
import { FALLBACK_CONFIG } from "@/data/config";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export function useBusinessData() {
  const [config, setConfig] = useState(FALLBACK_CONFIG);
  const [services, setServices] = useState([]);
  const [categoryNotes, setCategoryNotes] = useState({});
  const [vip, setVip] = useState(null);
  const [reviews, setReviews] = useState([]);
  const [media, setMedia] = useState([]);
  const [ratingMeta, setRatingMeta] = useState({
    rating: FALLBACK_CONFIG.google_rating,
    count: 0,
    url: FALLBACK_CONFIG.reviews_platform_url,
    platform: FALLBACK_CONFIG.reviews_platform,
  });

  useEffect(() => {
    let mounted = true;
    (async () => {
      try {
        const [c, s, r, m] = await Promise.all([
          axios.get(`${API}/config`),
          axios.get(`${API}/services`),
          axios.get(`${API}/reviews`),
          axios.get(`${API}/media`),
        ]);
        if (!mounted) return;
        setConfig(c.data);
        setServices(s.data.services || []);
        setCategoryNotes(s.data.category_notes || {});
        setVip(s.data.vip || null);
        setReviews(r.data.reviews || []);
        setRatingMeta({
          rating: r.data.rating,
          count: r.data.count,
          url: r.data.url,
          platform: r.data.platform || "Yelp",
        });
        setMedia(m.data.media || []);
      } catch (e) {
        console.warn("Business API not reachable, using fallback data.", e?.message);
      }
    })();
    return () => {
      mounted = false;
    };
  }, []);

  return { config, services, categoryNotes, vip, reviews, media, ratingMeta };
}

export function trackEvent(event_name, metadata = {}) {
  try {
    axios.post(`${API}/analytics`, { event_name, metadata }).catch(() => {});
  } catch {
    /* no-op */
  }
}
